<template>
    <div class="box-body" :style="boxStyle">
        <div class="box-container">
            <div class="box-title">{{title}}</div>
            <div class="box-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Box",
        props: ["width", "height", "title"],
        computed: {
            boxStyle() {
                let width = this.width ? (this.width * 100 / 1920) : 100
                let height = this.height ? (this.height * 100 / 1080) : 100
                return "width:" + width + "vw;" + "height:" + height + "vh;"
            }
        }
    }
</script>

<style lang="less" scoped>
    .box-body {
        background: #fff;
        box-shadow: 0 0 16rem 0 rgba(0, 43, 102, 0.04);
        display: flex;
        align-items: center;
        justify-content: center;

        .box-container {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            .box-title {
                font-size: 18rem;
                margin-left: 240/192vw;
                margin-top: 240/108vh;
                font-weight: bold;
                color: #333333;
            }

            .box-content {
                width: 100%;
                margin-left: 240/192vw;
                // overflow: hidden;
            }
        }
    }
</style>